import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiSelect: {
  defaultProps?: ComponentsProps['MuiSelect'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'];
  variants?: ComponentsVariants['MuiSelect'];
} = {
  styleOverrides: {
    root: {
      '& .MuiSelect-icon': {
        top: ' calc(50% - 12px)',
      },
    },
  },
};

export default muiSelect;
